import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          class: "btn btn-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.generateCSV && _ctx.generateCSV(...args)))
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
          _createTextVNode(" Télécharger Model ")
        ]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          type: "file",
          class: "form-control",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.lireCSVConvertirEnCsv($event))),
          accept: ".csv"
        }, null, 32),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.importer && _ctx.importer(...args)))
        }, "Importer")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[4] || (_cache[4] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Code ", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Loyer base ", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Marché ", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Type ", -1)),
              _withDirectives(_createElementVNode("th", _hoisted_8, " Motif ", 512), [
                [_vShow, _ctx.aMotif]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              }, " ACTIONS ", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.places, (place, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(place?.code), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(place?.montant), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(place?.marche), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(place?.type), 1),
                _withDirectives(_createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['badge', place?.motif =='Existe déjà' ? 'bg-danger' : 'bg-info'])
                  }, _toDisplayString(place?.motif), 3)
                ], 512), [
                  [_vShow, _ctx.aMotif]
                ]),
                _createElementVNode("td", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _cache[10] || (_cache[10] = _createElementVNode("button", {
                      class: "btn btn-sm btn-primary",
                      type: "button",
                      "data-bs-toggle": "dropdown",
                      "aria-expanded": "false"
                    }, " Actions ", -1)),
                    _createElementVNode("ul", _hoisted_16, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.suppression(place.code, _ctx.places))
                        }, _cache[9] || (_cache[9] = [
                          _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                          _createTextVNode(" Supprimer ")
                        ]), 8, _hoisted_17)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}